// import { Backdrop, CircularProgress } from '@material-ui/core';
// import { makeStyles } from '@material-ui/core/styles';
import React, { createContext, useReducer } from 'react';

const SET_HEADER_TEXT = 'SET_HEADER_TEXT';
const SET_SUB_HEADER_TEXT = 'SET_SUBHEADER_TEXT';
const SET_COMPONENTS = 'SET_COMPONENTS';

export const FinanceHeaderContext = createContext(null);

const initialState = {
  header: '',
  subHeader: '',
  component: () => null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_HEADER_TEXT:
    case SET_SUB_HEADER_TEXT:
    case SET_COMPONENTS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

const setHeaderAction = (str = '') => ({
  type: SET_HEADER_TEXT,
  payload: { header: str },
});
const setSubHeaderAction = (str = '') => ({
  type: SET_SUB_HEADER_TEXT,
  payload: { subHeader: str },
});
const setComponentsAction = (component = () => null) => ({
  type: SET_COMPONENTS,
  payload: { component },
});

const FinanceHeaderProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const setHeader = (str) => dispatch(setHeaderAction(str));
  const setSubHeader = (str) => dispatch(setSubHeaderAction(str));
  const setComponents = (component = () => null) =>
    dispatch(setComponentsAction(component));

  return (
    <FinanceHeaderContext.Provider
      value={{
        setHeader,
        setSubHeader,
        setComponents,
        ...state,
      }}>
      {children}
    </FinanceHeaderContext.Provider>
  );
};

export default FinanceHeaderProvider;
